import type { NonEmptyArray } from '../Types'

export const isNotEmpty = <T>(arr: T[] | readonly T[]): arr is NonEmptyArray<T> => arr.length > 0
